import React from "react";
import { useAppVersion } from "../../hooks/useAppVersion";

interface AppVersionProps {
  /**
   * Custom className for styling
   */
  className?: string;
  /**
   * Show "v" prefix before version number
   * @default true
   */
  showPrefix?: boolean;
  /**
   * Show as tooltip on hover
   * @default false
   */
  showTooltip?: boolean;
  /**
   * Custom prefix text instead of "v"
   */
  prefix?: string;
}

/**
 * Component to display the current application version
 */
export const AppVersion: React.FC<AppVersionProps> = ({
  className = "text-xs text-gray-500",
  showPrefix = true,
  showTooltip = false,
  prefix = "v",
}) => {
  const version = useAppVersion();
  const displayVersion = showPrefix ? `${prefix}${version}` : version;

  if (showTooltip) {
    return (
      <span
        className={className}
        title={`Application Version: ${displayVersion}`}
      >
        {displayVersion}
      </span>
    );
  }

  return <span className={className}>{displayVersion}</span>;
};

export default AppVersion;
